import { isObject } from "lodash";

export type RequestOptions = Omit<RequestInit, "body"> & {
  responseType?: "json" | "response";
  body?: any;
}

export async function http(url: string, config?: RequestOptions) {
  url = (process.env.REACT_APP_API_ROOT ?? '/') + url;
  config = { method: "GET", headers: {}, responseType: "json", ...config };

  if (isObject(config.body)) {
    (config.headers as any)["Content-Type"] = "application/json";
    config.body = JSON.stringify(config.body);
  }

  const resp = await fetch(url, config);

  if (config.responseType === "response")
    return resp;

  if (!resp.ok)
    throw resp;

  const contentLength = resp.headers.get("Content-Length");
  const contentType = resp.headers.get("Content-Type");

  if (contentLength === "0" || !contentType?.includes("application/json")) {
    return await resp.text();
  }

  return await resp.json();
}